module.exports = __webpack_public_path__ + "static/018.thumb-ac8a4a932ba906451fb031c50b865c68.jpg";